import React, { useState, useEffect } from 'react';
import { Layout, Menu } from 'antd';
import { ReactSVG } from 'react-svg';
// import {
//     UserOutlined,
//     VideoCameraOutlined,
//     UploadOutlined,
// } from '@ant-design/icons';
import './BaseLayoutComponent.styles.scss';
// import InfluencerTopHeaderComponent from '../../Influencer/Common/InfluencerTopHeaderComponent';
import TopHeaderComponent from '../../Admin/Common/TopHeaderComponent';
// import BrandTopSubHeaderComponent from '../../Brand/Common/BrandTopSubHeaderComponent';
import { IoHomeOutline } from 'react-icons/io5';
import { IoIosStats, IoIosCard } from 'react-icons/io';
import { AiFillNotification, AiOutlineUser } from 'react-icons/ai';
// import { HiUserGroup } from 'react-icons/hi';
// import { CgUserList} from 'react-icons/cg';
import { BiChat } from 'react-icons/bi';
import { ImStatsBars } from 'react-icons/im';
import { Link, useParams, useHistory, useLocation } from 'react-router-dom';
// import BrandCompanySelectComponent from '../../Brand/Common/BrandCompanySelectComponent';
// import { useGlobalState } from '../../../store/state';

const { Header, Sider, Content } = Layout;
const { Item } = Menu;

const BaseLayoutComponent = ({ children, topPush }) => {
  const history = useHistory();
  const location = useLocation();
  const [layoutControl, setLayoutControl] = useState({
    collapsed: false,
    optedKeys: '/influencer',
  });
  useEffect(() => {
    // setLayoutControl({
    //     ...layoutControl,
    //     optedKeys :  location.state.activeMenu //note: mockPath used to highlight dynamic inside routes as parent menu item
    // })
    console.log('location', location);
    if (location.state && location.state.activeMenu) {
      setLayoutControl({
        ...layoutControl,
        optedKeys: location.state.activeMenu, // note: mockPath used to highlight dynamic inside routes as parent menu item
      });
    } else {
      // setLayoutControl({
      //     ...layoutControl,
      //     optedKeys: history.location.pathname
      // })
    }
  }, []);

  const toggle = () =>{
    setLayoutControl({
      ...layoutControl,
      collapsed: !layoutControl.collapsed,
    });
  };
  const menuClick = ({ item, key, keyPath, domEvent }) =>{
    console.log('key', keyPath);
    setLayoutControl({
      ...layoutControl,
      optedKeys: keyPath,
    });
  };
  return (
    <div>
      <Sider
        className="side_layout"
        theme="light"
        trigger={null}
        collapsible
        width={270}
        collapsed={layoutControl.collapsed}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          borderRight: 'solid 1px #f1f1f1',
        }}
      >
        <div className="logo">
          <ReactSVG src="/images/brand-logo.svg"/>
        </div>
        <Menu
          onClick={menuClick}
          theme="light"
          mode="inline"
          defaultSelectedKeys={['/admin/dashboard']}
          selectedKeys={[layoutControl.optedKeys]}
        >
          <>
            <Item key={`admin`}
              icon={<IoHomeOutline/>}>
              <Link to={'/admin/dashboard'}>Home</Link>
            </Item>
            <Item key={`admin_campaigns`}
              icon={<AiFillNotification/>}>
              <Link to={`/admin/dashboard/campaigns`}>Campaigns</Link>
            </Item>
            <Item key={`admin_influencers`}
              icon={<ImStatsBars size={18}/>}>
              <Link to={`/admin/dashboard/influencers`}>Influencers</Link>
            </Item>
            <Item key={`admin_brands`}
              icon={<BiChat size={18} />}>
              <Link to={`/admin/dashboard/brands`}>brands</Link>
            </Item>
            <Item key={`admin_finance`}
              icon={<IoIosCard size={18}/>}>
              <Link to={`/admin/dashboard/finance`}>Financials</Link>
            </Item>
            {/* <Item key={`influencer_profile`} icon={<AiOutlineUser size={18}/>}>
                                <Link to={`/influencer/profile`}>Profile</Link>
                            </Item> */}
          </>

        </Menu>
      </Sider>
      <Layout className="site-layout">
        {/* <BrandTopHeaderComponent layoutControl={layoutControl} toggle={toggle}/> */}
        <TopHeaderComponent layoutControl={layoutControl}
          toggle={toggle}/>
        <Content
          className="site-layout-background"
          style={{
            // margin: '64px 16px 24px 16px',
            margin: `${topPush || 64}px 0 24px 0`,
            marginLeft: layoutControl.collapsed ? '80px':'270px',
            transition: 'all 0.2s',
            // padding: 24,
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          {children}
          {/* <BrandTopSubHeaderComponent>
                        Welcome!
                    </BrandTopSubHeaderComponent>
                    <div style={{padding:24}}>
                        <Row gutter={16}>
                        </Row>
                    </div> */}
        </Content>
      </Layout>
    </div>
  );
};

export default BaseLayoutComponent;
